export default "__VITE_ASSET__BLDcyABI__"